import { SelectedVariants } from '@wix/bookings-uou-types';
import { FormValues } from '@wix/form-viewer';
import { WixFormFields } from '../../types/wix-forms';
import { Participant, SlotService } from '../state/types';

export const EMPTY_PARTICIPANT_VARIANT: SelectedVariants = {
  numberOfParticipants: 0,
  choices: [],
};

let participantSequence = 0;

/**
 * Stable identity for a participant. The widget keys its (local) form values and DOM
 * refs by it, so add/remove never re-associates one participant's data with another.
 */
export const createParticipantId = (): string =>
  `participant-${Date.now().toString(36)}-${(participantSequence++).toString(
    36,
  )}`;

export const createParticipant = (
  overrides: Partial<Participant> = {},
): Participant => ({
  id: createParticipantId(),
  selectedAddons: {},
  ...overrides,
});

export const getParticipants = (slotService?: SlotService): Participant[] =>
  slotService?.participants ?? [];

/** Returns a copy of the participants list with `patch` merged into participant `index`. */
export const patchParticipant = (
  participants: Participant[] | undefined,
  index: number,
  patch: Partial<Omit<Participant, 'id'>>,
): Participant[] => {
  const next = [...(participants ?? [])];
  next[index] = { ...(next[index] ?? createParticipant()), ...patch };
  return next;
};

export const getParticipantVariants = (
  participants: Participant[] | undefined,
): (SelectedVariants | undefined)[] =>
  (participants ?? []).map((participant) => participant.selectedVariant);

/** "First Last" from a participant's form values, empty until something is typed. */
export const getParticipantName = (values: FormValues = {}): string =>
  [values[WixFormFields.FIRST_NAME], values[WixFormFields.LAST_NAME]]
    .filter((part) => typeof part === 'string' && part.trim())
    .join(' ');
